const determineParamsValidation = (params, paramsTypes) => {
  if (!params || !paramsTypes) {
    return {
      isValid: false,
      invalidParams: [],
    }
  }
  const invalidParams = []
  for (let [paramName, paramType] of Object.entries(paramsTypes)) {
    const actualParamType = typeof params[paramName]
    if (actualParamType !== paramType) {
      invalidParams.push({
        paramName,
        expectedType: paramType,
        actualParamType,
      })
    }
  }
  if (invalidParams.length > 0) {
    return {
      isValid: false,
      invalidParams,
    }
  }
  return {
    isValid: true,
    invalidParams: [],
  }
}

/**
 *
 * Check if the params are valid
 * @param {Object} params params to validate eg. {param1: 'abc', param2: 123}
 * @param {Object} paramsTypes expected params types eg. {param1: 'string', param2: 'number'}
 * @param {Object} PCLNAnalytics logger instance
 * @param {string} functionName
 * @param {string} fileName
 * @returns {boolean} true if params are valid, false otherwise
 * @sideeffects logs all params not matching the expected type
 */
export const validateParams = ({ params, paramsTypes, PCLNAnalytics, functionName, fileName }) => {
  if (!PCLNAnalytics) {
    return
  }
  const { isValid, invalidParams } = determineParamsValidation(params, paramsTypes)
  if (!isValid) {
    PCLNAnalytics.logError({
      message: `Invalid Parameters passed to  - ${functionName ?? ''} ${fileName ?? ''}: ${JSON.stringify(
        invalidParams
      )}`,
    })
  }
  return isValid
}
